import { Field, FieldProps, ErrorMessage } from "formik"
import { classNames } from "primereact/utils"
import { Dropdown, DropdownChangeEvent, DropdownProps } from "primereact/dropdown"

const DropdownField = ({
  field,
  options,
  label,
  className,
  inputClassName,
  horizontal,
  disabled,
  optionLabel = "label",
  optionValue = "value",
  filterBy,
  showClear,
  panelClassName,
  validation,
  handleChange,
  ...dropdownProps
}: Props) => (
  <Field name={field} validate={validation}>
    {({ field: { name, value, onChange }, meta: { touched, error } }: FieldProps) => (
      <div
        className={classNames(
          "field relative space-y-2",
          horizontal ? "inline-flex justify-between" : "flex flex-col",
          className,
        )}
      >
        {label && (
          <label
            htmlFor={name}
            className={classNames("font-medium text-gray-500 text-sm", { "mr-3 mb-0 mt-2": horizontal })}
          >
            {label}
          </label>
        )}
        <div className="flex flex-col w-full">
          <Dropdown
            id={name}
            name={name}
            optionLabel={optionLabel}
            optionValue={optionValue}
            options={options}
            onChange={
              handleChange
                ? (e) => {
                    handleChange(e)
                    onChange(e)
                  }
                : onChange
            }
            value={value}
            disabled={disabled}
            showClear={showClear}
            filter={filterBy !== undefined && options && options.length > 0}
            filterBy={filterBy}
            className={classNames(
              "p-inputtext-sm h-10",
              { "p-invalid": touched && error, horizontal: horizontal },
              inputClassName,
            )}
            panelClassName={panelClassName}
            {...dropdownProps}
          />
          <div className="flex items-start p-error h-2 mt-1">
            <ErrorMessage name={field}>{(msg) => <small>{msg}</small>}</ErrorMessage>
          </div>
        </div>
      </div>
    )}
  </Field>
)

type Props = {
  field: string
  options: any
  label?: string
  className?: string
  disabled?: boolean
  optionLabel?: string
  optionValue?: string
  inputClassName?: string
  horizontal?: boolean
  showClear?: boolean
  filterBy?: string
  panelClassName?: string
  validation?(value: string): void
  handleChange?(e: DropdownChangeEvent): void
} & DropdownProps

export { DropdownField }
